// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"06bf111b","115":"20701c97","420":"cd1497f4","453":"8ab44547","517":"d6a6c00f","571":"33ed8fc8","741":"798234a0"}[chunkId] + ".chunk.js";
};